<template>
    <div></div>
</template>
<script>

    export default {
        props: ['value','isModal'],
        data () {
            return {
                /*
                config: {
                    imageUploadURL: '/upload_image',
                    events: {
                        'froalaEditor.initialized': function () {
                            console.log('initialized')
                        }
                    },
                    useClasses: false,
                    htmlAllowedTags: ['.*'],
                    htmlRemoveTags: [''],
                    fullPage: true,
                    lineBreakerTags: [''],
                    linkAlwaysBlank: true,
                    toolbarButtons: {
                        'moreText': {
                            'buttons': ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize', 'textColor', 'backgroundColor', 'inlineClass', 'inlineStyle', 'clearFormatting']
                        },
                        'moreParagraph': {
                            'buttons': ['alignLeft', 'alignCenter', 'formatOLSimple', 'alignRight', 'alignJustify', 'formatOL', 'formatUL', 'paragraphFormat', 'paragraphStyle', 'lineHeight', 'outdent', 'indent', 'quote']
                        },
                        'moreRich': {
                            'buttons': ['insertLink', 'insertImage', 'insertTable', 'emoticons', 'fontAwesome', 'specialCharacters']
                        },
                        'moreMisc': {
                            'buttons': ['undo', 'redo', 'fullscreen', 'html']
                        }
                    }
                },
                */
                resource: {},
                locale_default: null,
                locale: null,
                locales: null,
                localesLoaded: null,
                acl_authorizations: [],
                initialized:false,
                className:"modal-fade-enter-active",
            }
        },
        created: function() {
        },
        mounted: function(){
            this.locale_default = this.$store.state.scope.locales[0].id,
            this.locale = this.$store.state.scope.locales[0].id,
            this.locales = this.$store.state.scope.locales

            if( this.value && this.isModal )
            {
                this.resource = this.value;
            }

            self = this;
            document.onkeydown=function(event){
                if((event.ctrlKey || event.metaKey) && event.which == 83) {
                    event.preventDefault();
                    self.submit()
                    return false;
                }
            }

            if( this.$route.meta.action == "edit" && !this.isModal ){

                this.get();

            }else{

                this.getNew();
                /*
                setTimeout(function(){
                    self.modalClass = "show";
                    self.resourceLoaded();
                }, 50);*/

            }
        },
        watch: {
        },
        methods:{
            copy:function(original) {
                return JSON.parse(JSON.stringify(original));
            },
            setTranslationsTo: function(obj, fields){

                //console.log('setTranslationsTo', obj.translations);

                let trans = obj.translations ? this.copy(obj.translations) : null;
                //if( trans && !trans[0] ){ console.log("no"); return false; }

                let translations = {};
                for (var i=0 ; i<this.locales.length ; i++ ) {
                    let locale = this.locales[i];
                    translations[locale.id] = {};
                    let founded = false;
                    if( obj.translations ) {

                        $.each(obj.translations, function(index, value){
                            //console.log("---A---", index, obj.translations[index].locale);

                            let lang = obj.translations[index].locale !== undefined ? obj.translations[index].locale : index;

                            let item = obj.translations[index];
                            if (lang == locale.id) {
                                for (var x = 0; x < fields.length; x++) {
                                    translations[lang][fields[x]] = item[fields[x]];
                                }
                                founded = true;
                            }

                        });

                        /*
                        for (var a = 0; a < obj.translations.length; a++) {

                            console.log("---B---", a, obj.translations[a].locale);

                            let item = obj.translations[a];
                            if (item.locale == locale.id) {
                                for (var x = 0; x < fields.length; x++) {
                                    translations[locale.id][fields[x]] = item[fields[x]];
                                }
                                founded = true;
                            }
                        }*/
                    }
                    if( !founded ){
                        for ( var x=0 ; x<fields.length ; x++ ) {
                            translations[locale.id][fields[x]] = "";
                        }
                    }
                }
                //console.log('setTranslationsTo end', translations);
                obj.translations = translations;

                if( this.$route.meta.action == "new" ){ this.localesLoaded = true; }
            },
            setTranslations: function(fields){
                this.setTranslationsTo(this.resource, fields);
                this.localesLoaded = true;
            },
            resourceLoaded: function(){
                this.localesLoaded = true;
                self.initialize();
            },
            get: function(){
                let self = this;
                this.getResource().get(this.$route.params.id).then((response) => {
                  setTimeout(function(){
                    self.resource = response.data
                    self.resourceLoaded();
                    self.initialize();
                  }, 0)
                })
            },
            getNew: function(){
                let self = this;
                this.getResource().get('new').then((response) => {
                    self.resource = response.data
                    self.resourceLoaded();
                    self.initialize();
                    //console.log('--------getNew', self.resourceLoaded,  self.resource)
                })
            },
            beforeUpdate: function(Resource){
                return true;
            },
            submit: function(callback){

                let Resource = Object.assign({}, this.resource);

                if( !this.beforeUpdate(Resource) ){
                    return false;
                }

                Resource._axioMessageSuccess = true;

                if( this.$route.meta.action == "edit" && !this.isModal ){

                    // KMO - ACL Array check - add to resource if is set
                    if(this.acl_authorizations.length > 0){
                        Resource.acl = this.acl_authorizations;
                    }

                    this.getResource().update(this.$route.params.id, Resource).then((response) => {
                        this.$emit('refresh', this);
                        if( !callback ){
                            this.close();
                        }else{
                            callback()
                        }
                    })
                }else{
                    this.getResource().create(Resource).then((response) => {

                        if( this.isModal )
                        {
                            this.$emit('validate', response.data);
                        }else{
                            this.$emit('refresh', this);
                            if( !callback ){
                                this.close(response.data.id);
                            }else{
                                callback()
                            }
                        }
                    })
                }
            },
            close: function(id){

              if( this.className == "" && !this.isModal ){
                let name = this.$route.name.replace('-edit', '').replace('-new', '')
                //name = self.$route.meta.parent ? self.$route.meta.parent : name
                this.$router.push({name: name});
              }
              this.$emit('close');

            },
            back: function(id){

              let ask = confirm("Etes-vous certain de vouloir fermer cette fenêtre ?");
              if( ask && this.getResource() ){

                this.close(id);

              }
            },
            duplicate: function(id){
                let ask = confirm("Etes-vous certain de vouloir dupliquer cet élément ?");
                if( ask && this.getResource() ){
                    this.getResource().duplicate(id).then((response) => {
                        //this.refresh()
                        this.$emit('refresh', this);
                        this.back();
                    })
                }
            },
            remove: function(){
                let ask = confirm("Etes-vous certain de vouloir supprimer cet élément ?");
                if( ask && this.getResource() ){
                    this.getResource().delete(this.resource.id).then((response) => {
                        //this.refresh()
                        this.$emit('refresh', this);
                        this.back();
                    })
                }
            },
            initialize: function(){
                var self = this;
                setTimeout(function(){self.className = ""}, 100)
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/layouts/Edit.vue